// extracted by mini-css-extract-plugin
module.exports = {"list":"SocialLinks_list__1u86w","link":"SocialLinks_link__wKBUr","path":"SocialLinks_path__ayh6O"};